import { Component, h, Prop } from '@stencil/core';
import state from '@ugc-store';
import { ReportAbuseType } from '@ugc-containers/ugc-report-abuse/interfaces';
import { IAnswer, UserType } from '@ugc-components/ugc-pdp-question-and-answer/interfaces';
import { FontType, isRtl, PageType } from '@ugc-utils/utils';
import { modalZIndex } from '@ugc-utils/modal-z-index';

@Component({
  tag: 'ugc-answer-item',
  shadow: false,
})
export class UgcAnswerItem {
  @Prop() index?: number = 0;
  @Prop() isModal?: boolean = false;
  @Prop() answer: IAnswer;

  render() {
    const {
      qnaStaticLanguage: {
        IDS_COM_VENDOR_COMMENT_DISCLAIMER_TEXT = '',
        IDS_MSG_SHOW_MORE = '',
        IDS_MSG_SHOW_LESS = '',
      },
      isDesktop,
      productInfo: { brandName, brandUrl, brandLogoUrl },
    } = state;

    const {
      id: aid = '',
      questionId: qid = '',
      userType = UserType.Customer,
      content = '',
      customerNickname = '',
      customerProfileLink = '',
      postedDateLocalized = '',
      hasRewarded = false,
      hasThumbsUp,
      helpfulYes = 0,
      helpfulNo = 0,
      verifiedPurchase = false,
      isBest = false,
      profileImageUrl = '',
      answerShareUrl = '',
    } = this.answer;
    const isLargeType = isDesktop && !this.isModal;
    const fontType = isLargeType ? FontType.large : FontType.small;
    return (
      <div
        class={`p-16 mt-16 ${this.isModal ? 'bg-white' : 'bg-gray-200'} ${isLargeType ? 'rounded-16' : 'rounded-8'}`}
      >
        <div class={`flex-row-between-center flex-wrap mb-16 gap-8`}>
          {userType === UserType.Customer ? (
            <ugc-answer-customer
              profileImageUrl={profileImageUrl}
              customerNickname={customerNickname}
              customerProfileLink={customerProfileLink}
              fontType={fontType}
            />
          ) : userType === UserType.Vendor ? (
            <a href={brandUrl} class="flex-row-start-center  gap-4 color-blue-dark flex-wrap">
              {!!brandLogoUrl && <img src={brandLogoUrl} style={{ width: '105px', height: '30px' }} alt="brand logo" />}
              <span class="fs-14">{brandName}</span>
              <ugc-answer-sign userType={userType} />
            </a>
          ) : (
            <ugc-answer-sign userType={userType} />
          )}

          <div class={`fs-14 color-gray-600`}>{postedDateLocalized}</div>
        </div>

        <ugc-answer-labels
          verifiedPurchase={verifiedPurchase}
          hasRewarded={hasRewarded}
          isBest={isBest}
          fontType={fontType}
        />

        <div class="mt-4 mb-12" style={isLargeType && { maxWidth: '700px' }}>
          <ugc-ellipsis-text
            line={isLargeType ? 3 : 6}
            text={content}
            readMore={IDS_MSG_SHOW_MORE}
            readLess={IDS_MSG_SHOW_LESS}
            contentStyle={{ fontSize: isLargeType ? '16px' : '14px' }}
            buttonStyle={{ fontSize: isLargeType ? '14' : '12px' }}
            iconSize={isLargeType ? '24' : '15'}
          />
        </div>

        {userType === UserType.Customer && <ugc-medical-disclaimer pageType={PageType.qna} />}

        {userType === UserType.Vendor && (
          <p class={`${isLargeType ? 'fs-14' : 'fs-12'} mb-16 color-gray-600`}>
            {IDS_COM_VENDOR_COMMENT_DISCLAIMER_TEXT}
          </p>
        )}

        <div class="flex-row-between-center py-8">
          <ugc-qna-vote
            aid={aid}
            qid={qid}
            hasThumbsUp={hasThumbsUp}
            helpfulYes={helpfulYes}
            helpfulNo={helpfulNo}
            fontType={fontType}
          />
          <div class={`flex-row-start-center ${isDesktop && !this.isModal && 'gap-14'}`}>
            {userType === UserType.Customer && (
              <ugc-report-abuse
                type={ReportAbuseType.Answer}
                referenceId={aid}
                fontType={fontType}
                data-testid="pdp-qna-answer-report-abuse"
              />
            )}
            <div class="lh-16">
              <ugc-share
                sid={`${isDesktop}-${this.isModal}-${aid}`}
                shareWidgetLayer={this.isModal && modalZIndex['share-widget-layer']}
                shareUrl={answerShareUrl}
                position={isRtl() ? 'right' : 'left'}
                gaEvent={{
                  'data-ga-event-name': 'open_share_widget',
                  'data-ga-content-type': 'qna',
                  'data-ga-location-detail': 'pdp qna',
                }}
                data-testid="pdp-qna-answer-share"
                fontType={fontType}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
